import { Scheduling } from "../../models/schedule";

interface ICard {
    setShowDialog: (showDialog: boolean) => void;
    chooseScheduling: () => void;
    scheduling: Scheduling;
}

const Card = ({ setShowDialog, scheduling, chooseScheduling }: ICard) => {
    return (
        <div
            className="alert alert-dismissible alert-info cursor-pointer my-10"
            onClick={() => {
                chooseScheduling();
                setShowDialog(true);
            }}
        >
            <div className="display-flex gap-10">
                <div className="w-full">
                    <div className="alert-header flex justify-between">
                        <strong>Revisão {scheduling.checkup?.description}</strong>
                        <strong>
                            {new Date(scheduling.date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                        </strong>
                    </div>
                    <div className="margin-y-5 flex flex-column">
                        <div>{scheduling.asset?.name}</div>
                        <div>Chassi: {scheduling.asset?.chassis}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Card;